const navbar = {
  packages: "الحزم", // translated 
  hotelPackages: "باقات الفنادق", // translated 
  experiences: "خبرة", // translated 
  close: "يغلق", // translated 
  hotDeals: "العروض الساخنة", // translated 
  dashboard: "لوحة القيادة", // translated 
  pricing: "التسعير", // translated 
};




export default navbar;
